




































































































































interface Series {
  id: number
  name: string
  chartType: string
  dataLog: string
  measurement: string
  color: string
  customQuery: string
  edit: boolean
}

interface SelectOption {
  value: string | number
  text?: string
}

interface DataLogDictionary {
  [key: string]: DataLog
}

import Vue from 'vue'

import { FindWithItems } from '@/api/data-logger'

function getRandomColor() {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

import { DataLog } from '../../types/data-log'
export default Vue.extend({
  props: {
    value: Array,
  },
  data() {
    return {
      chartTypes: [
        { value: 'line', text: 'Line' },
        { value: 'bar', text: 'Bar' },
      ],
      selectedIndex: -1,
      model: [] as Series[],
      addItemEnabled: false,
      newSeries: {
        id: -1,
        name: '',
        chartType: 'line',
        dataLog: '',
        measurement: '',
        color: getRandomColor(),
        customQuery: '',
        edit: false,
      } as Series,

      datalogs: [] as DataLog[],
    }
  },

  computed: {
    datalogOptions(): SelectOption[] {
      return this.datalogs.map((item: DataLog) => {
        return { value: item.id, text: item.name }
      })
    },
    datalogDictionary() {
      const dictionary: DataLogDictionary = {}
      for (const i in this.datalogs) {
        dictionary[this.datalogs[i].id] = this.datalogs[i]
      }
      return dictionary
    },
  },

  methods: {
    async find() {
      this.datalogs = await FindWithItems()
    },

    measurementOptions(datalogId: number): SelectOption[] {
      if (datalogId && this.datalogDictionary[datalogId]) {
        return this.datalogDictionary[datalogId].items.map((item) => {
          return {
            text: item.name,
            value: item.tagUID,
          }
        })
      }

      return []
    },
    async loadRequiredData() {
      await this.find()
    },
    enableAddItem() {
      this.addItemEnabled = true
    },
    cancelAddRow() {
      this.addItemEnabled = false
      this.newSeries = {
        id: -1,
        name: '',
        chartType: 'line',
        dataLog: '',
        measurement: '',
        color: getRandomColor(),
        customQuery: '',
        edit: false,
      }
    },
    applyNewSeries() {
      // this.generateRawQuery(this.newSeries)
      this.model.push({ ...this.newSeries, id: this.model.length })

      this.addItemEnabled = false
      this.newSeries.name = ''
      this.newSeries.chartType = 'line'
      this.newSeries.dataLog = ''
      this.newSeries.measurement = ''
      this.newSeries.color = getRandomColor()
      this.newSeries.customQuery = ''
      this.newSeries.edit = false
    },

    isActiveRow(index: number) {
      return this.selectedIndex == index
    },

    handleRowClick(index: number) {
      this.selectedIndex = index
    },
    handleRowDbClick() {
      //
    },

    parseValue() {
      this.model = this.value as Series[]
    },
  },

  watch: {
    value: function(val: Series[]) {
      if (JSON.stringify(this.model) != JSON.stringify(val)) {
        this.parseValue()
      }
    },
    model: {
      deep: true,
      handler: function(val: Series[]) {
        this.$emit('input', val)
      },
    },
  },

  created() {
    this.loadRequiredData()
    this.parseValue()
  },
})
